import { FormControl, InputLabel, Select, MenuItem, Box } from '@mui/material'
import { FormattedMessage } from 'react-intl'
import { SelectChangeEvent } from '@mui/material/Select'
import {Product} from "../../apis/configuration/dto";

interface ProductContentProps {
  availableProducts: Product[]
  selectedProduct: string | null
  handleProductChange: (event: SelectChangeEvent<string>) => void
  productError: boolean
}

const ProductContent = ({
  availableProducts,
  selectedProduct,
  handleProductChange,
  productError
}: ProductContentProps) => {
  return (
    <Box sx={{ display: 'flex', justifyContent: 'center' }}>
      <FormControl
        sx={{ width: { xs: 300, sm: 400, marginBottom: "5px"} }}
        error={productError}
      >
        <InputLabel>
          <FormattedMessage id="page.homePage.select.product" />
        </InputLabel>
        <Select
          label={<FormattedMessage id="page.homePage.select.product" />}
          value={selectedProduct || ''}
          onChange={handleProductChange}
        >
          {availableProducts.map((product) => (
            <MenuItem key={product.id} value={product.id}>
                {product.name} {product.duration && `- ${product.duration / 60}h`}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  )
}

export default ProductContent
